import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Footer() {
  const footerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.footer
      className="footer glass-morphism"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={footerVariants}
    >
      <div className="footer-content">
        <motion.div className="footer-section about" variants={itemVariants}>
          <h3>
            <span className="gradient-text">Oasis</span>Logic
          </h3>
          <p>Your partner in innovative technology solutions. We help businesses thrive in the digital age through AI, web development, and strategic marketing.</p>
          <div className="tech-stack">
            <span className="tech-badge">AI</span>
            <span className="tech-badge">Web3</span>
            <span className="tech-badge">Cloud</span>
            <span className="tech-badge">IoT</span>
          </div>
        </motion.div>

        <motion.div className="footer-section links" variants={itemVariants}>
          <h3>Quick Links</h3>
          <ul>
            <motion.li whileHover={{ x: 5 }} whileTap={{ scale: 0.95 }}>
              <Link to="/">Home</Link>
            </motion.li>
            <motion.li whileHover={{ x: 5 }} whileTap={{ scale: 0.95 }}>
              <Link to="/services">Services</Link>
            </motion.li>
            <motion.li whileHover={{ x: 5 }} whileTap={{ scale: 0.95 }}>
              <Link to="/projects">Projects</Link>
            </motion.li>
            <motion.li whileHover={{ x: 5 }} whileTap={{ scale: 0.95 }}>
              <Link to="/blog">Blog</Link>
            </motion.li>
            <motion.li whileHover={{ x: 5 }} whileTap={{ scale: 0.95 }}>
              <Link to="/contact">Contact Us</Link>
            </motion.li>
          </ul>
        </motion.div>

        <motion.div className="footer-section contact-info" variants={itemVariants}>
          <h3>Contact Us</h3>
          <motion.div 
            className="contact-item"
            whileHover={{ scale: 1.02 }}
          >
            <i className="fas fa-envelope"></i>
            <p>contact@oasislogic.tech</p>
          </motion.div>
          <motion.div 
            className="contact-item"
            whileHover={{ scale: 1.02 }}
          >
            <i className="fas fa-phone"></i>
            <p>+971 43 868974</p>
          </motion.div>
          <motion.div 
            className="contact-item"
            whileHover={{ scale: 1.02 }}
          >
            <i className="fas fa-map-marker-alt"></i>
            <p>Unit 1004, IT Plaza, <br />Dubai Silicon Oasis, Dubai, UAE</p>
          </motion.div>
        </motion.div>

        <motion.div className="footer-section social" variants={itemVariants}>
          <h3>Connect With Us</h3>
          <div className="social-icons">
            {[
              { icon: 'fab fa-linkedin-in', url: '#', label: 'LinkedIn' },
              { icon: 'fab fa-twitter', url: '#', label: 'Twitter' },
              { icon: 'fab fa-github', url: '#', label: 'GitHub' },
              { icon: 'fab fa-instagram', url: '#', label: 'Instagram' }
            ].map((social, index) => (
              <motion.a
                key={index}
                href={social.url}
                aria-label={social.label}
                whileHover={{ 
                  scale: 1.2,
                  color: '#38bdf8',
                  transition: { duration: 0.2 }
                }}
                whileTap={{ scale: 0.9 }}
              >
                <i className={social.icon}></i>
              </motion.a>
            ))}
          </div>
          <motion.div 
            className="newsletter-signup"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h4>Stay Updated</h4>
            <div className="input-group">
              <input type="email" placeholder="Enter your email" />
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="subscribe-btn"
              >
                Subscribe
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      </div>

      <motion.div 
        className="footer-bottom"
        variants={itemVariants}
      >
        <p>© {new Date().getFullYear()} OasisLogic. All rights reserved.</p>
        <div className="footer-bottom-links">
          <motion.a href="#" whileHover={{ color: '#38bdf8' }}>Privacy Policy</motion.a>
          <motion.a href="#" whileHover={{ color: '#38bdf8' }}>Terms of Service</motion.a>
          <motion.a href="#" whileHover={{ color: '#38bdf8' }}>Sitemap</motion.a>
        </div>
      </motion.div>
    </motion.footer>
  );
}

export default Footer;
